<template>
  <div>
    <DailySales />
  </div>
</template>

<script>
import DailySales from '../components/SalesTracking/dailySales.vue';

export default {
  components: { DailySales },
  mounted() {
    this.auth();
  },
  methods: {
    auth() {
      this.axios.get(`${this.baseUrl}/dashboard/auth`, this.$store.getters.authHeader)
        .catch(() => {
          this.$router.push('/');
        });
    },
  },
};
</script>

<style>

</style>
